module.exports = __webpack_public_path__ + "static/img/news_03.8a6fa21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_03.jpg
// module id = Opvo
// module chunks = 2